import './wdyr';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/es/object';
import 'shared/utils/modernizr';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import {
  initializeLibrary,
  ModalContextProvider,
  OnboardingThemeContextProvider,
} from '@figure/figure-frontlib-gui';
import { Provider as ReduxProvider } from 'react-redux';
import i18n from 'i18next';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import { setLocale } from 'yup';
import store from 'store';
import App from 'App';
import { getTheme } from 'shared/utils/url';
import * as serviceWorker from './serviceWorker';

const theme = getTheme();

initializeLibrary();

// default all Required messages to 'Required'
setLocale({
  mixed: {
    required: 'Required',
  },
});

/**
 * White-labeling.
 *
 * For all options read: https://www.i18next.com/overview/configuration-options
 */
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: theme,
    fallbackLng: theme,

    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/translation.json`,
    },
  });

/**
 * Root component.
 */
ReactDOM.render(
  <ReduxProvider store={store}>
    <Suspense fallback="">
      <I18nextProvider i18n={i18n}>
        <OnboardingThemeContextProvider>
          <ModalContextProvider>
            <App />
          </ModalContextProvider>
        </OnboardingThemeContextProvider>
      </I18nextProvider>
    </Suspense>
  </ReduxProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
